import script from "./TransferLeadsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferLeadsModal.vue?vue&type=script&setup=true&lang=js"

import "./TransferLeadsModal.vue?vue&type=style&index=0&id=d7711c16&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7711c16"]])

export default __exports__